module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_10.6a0bc0b7.jpg";